import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class OnboardingStore {

}

export enum OnboardingStoreKeys {

}
